/**
 * Files API handler
 */

import type { RouteContext } from '../types';

export async function filesHandler(context: RouteContext): Promise<any> {
  const { request, config } = context;
  const method = request.method;

  if (method === 'GET') {
    return await handleFilesGet(context);
  }

  if (method === 'POST') {
    return await handleFilesPost(context);
  }

  if (method === 'PUT') {
    return await handleFilesPut(context);
  }

  if (method === 'DELETE') {
    return await handleFilesDelete(context);
  }

  throw new Error(`Method ${method} not supported for files endpoint`);
}

async function handleFilesGet(context: RouteContext): Promise<any> {
  const { request } = context;
  const url = new URL(request.url);
  const path = url.searchParams.get('path');

  if (path) {
    // Read single file
    return {
      path,
      content: `File content for ${path}`,
      size: 100,
      modified: new Date().toISOString(),
      encoding: 'utf8',
    };
  } else {
    // List files
    return {
      files: [
        { path: './README.md', type: 'file', size: 1024 },
        { path: './docs', type: 'directory', size: 0 },
      ],
      total: 2,
    };
  }
}

async function handleFilesPost(context: RouteContext): Promise<any> {
  return {
    success: true,
    message: 'File operation completed',
  };
}

async function handleFilesPut(context: RouteContext): Promise<any> {
  return {
    success: true,
    message: 'File updated',
  };
}

async function handleFilesDelete(context: RouteContext): Promise<any> {
  return {
    success: true,
    message: 'File deleted',
  };
}